import { Component, OnInit, Input } from '@angular/core';
import { LiveUpdateService } from '../shared/live-update.service';
import { Campaign } from '../shared/models/campaign';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ae-campaign-form',
  templateUrl: './campaign-form.component.html',
  styles: []
})
export class CampaignFormComponent implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('campaign') public campaign: Campaign;
  @Input('error') public error: string
  public campaigns: Campaign[] = []
  public campaignForm: NgForm;
  constructor(private liveUpdateService: LiveUpdateService, private datePipe: DatePipe) { }

  ngOnInit() {
    this.liveUpdateService.campaigns$.subscribe((campaigns: Campaign[]) => {
      this.campaigns = campaigns;
    })
  }

  toggleEditSave() {
    this.campaign.readonly = this.campaign.readonly ? false : true;
  }

  cancel(campForm: NgForm) {
    this.campaign.readonly = true;
    campForm.resetForm(this.campaign);
  }

  save() {
   this.campaign.stringDate = this.datePipe.transform(this.campaign.stringDate.toString(), 'shortDate');
   this.campaign.readonly = true;
   this.liveUpdateService.updateCampaigns(this.campaign);
  }

  deleteRecord() {
    if (this.campaigns.length > 2) {
      this.liveUpdateService.deleteRecord(this.campaign);
    } else {
      this.error = "Can't delete record because it would leave 0 records in database."
    }
  }
}
